var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 54,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#18b637",
    d: "m-6.8 0 33.5 20-33.5 20zm67 0L26.7 20l33.5 20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf0921",
    d: "m-6.8 0 33.5 20L60.2 0zm0 40 33.5-20 33.5 20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60.2 0h-6.3L-6.8 36.3V40h6.2L60.2 3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38.2 20a11.6 11.6 0 1 1-23 0 11.6 11.6 0 0 1 23 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-6.8 0v3.7L53.9 40h6.3v-3.7L-.6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf0921",
    stroke: "#18b637",
    strokeWidth: 0.5,
    d: "M29 15.6h-1.6l-.7 1.3-.8-1.2h-1.5l.7-1.4-.7-1.3h1.5l.8-1.3.8 1.3H29l-.8 1.3zm-5.1 8.8h-1.5l-.8 1.3-.8-1.3h-1.5l.8-1.4-.7-1.3h1.5l.7-1.3.8 1.3H24l-.7 1.3zm10.2 0h-1.5l-.8 1.3-.8-1.3h-1.4l.7-1.4-.7-1.3H31l.7-1.3.8 1.3H34l-.7 1.3z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBi);
export default __webpack_public_path__ + "static/media/bi.d142fb77040bc2abc621d836b888679d.svg";
export { ForwardRef as ReactComponent };